import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTheme } from '../utils/theme';

export default function Navbar() {
  const location = useLocation();
  const isActive = (path) => location.pathname === path;
  const { theme, toggle } = useTheme();
  const [menuOpen, setMenuOpen] = useState(false);

  const navLinks = [
    { to: '/', label: 'Home' },
    { to: '/new', label: 'New Audit' },
    { to: '/dashboard', label: 'Dashboard' },
    { to: '/portfolio', label: 'Portfolio' },
  ];

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-black/95 backdrop-blur-md border-b border-neutral-800/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="flex items-center justify-between h-14 sm:h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 sm:gap-3 group">
            <img
              src={theme === 'light' ? 'https://static.wixstatic.com/media/cf458d_d665b41d1e64456698455172873d1399~mv2.png' : 'https://static.wixstatic.com/media/cf458d_f7329a8f179a4571a1951c4ed9431604~mv2.png'}
              alt="Next Experience Group"
              className="h-7 sm:h-8 w-auto"
            />
            <span className="font-display font-bold text-brand-gold text-base sm:text-lg tracking-wider hidden xs:inline">What's NEXT</span>
          </Link>

          {/* Desktop nav */}
          <div className="hidden sm:flex items-center gap-1 sm:gap-2">
            {navLinks.map(link => (
              <Link
                key={link.to}
                to={link.to}
                className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-all ${
                  isActive(link.to) ? 'bg-neutral-800 text-brand-gold' : 'text-neutral-400 hover:text-white hover:bg-neutral-800/50'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <button
              onClick={toggle}
              className="ml-2 w-8 h-8 rounded-lg flex items-center justify-center text-neutral-500 hover:text-brand-gold hover:bg-neutral-800/50 transition-all"
              title={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}
            >
              {theme === 'dark' ? '☀️' : '🌙'}
            </button>
          </div>

          {/* Mobile: theme toggle + hamburger */}
          <div className="flex sm:hidden items-center gap-2">
            <button
              onClick={toggle}
              className="w-9 h-9 rounded-lg flex items-center justify-center text-neutral-500 hover:text-brand-gold"
            >
              {theme === 'dark' ? '☀️' : '🌙'}
            </button>
            <button
              onClick={() => setMenuOpen(!menuOpen)}
              className="w-9 h-9 rounded-lg flex items-center justify-center text-neutral-400 hover:text-white"
            >
              {menuOpen ? '✕' : '☰'}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu dropdown */}
      {menuOpen && (
        <div className="sm:hidden bg-black/95 border-t border-neutral-800/50 px-4 py-3 space-y-1">
          {navLinks.map(link => (
            <Link
              key={link.to}
              to={link.to}
              onClick={() => setMenuOpen(false)}
              className={`block px-4 py-3 rounded-lg text-sm font-medium transition-all ${
                isActive(link.to) ? 'bg-neutral-800 text-brand-gold' : 'text-neutral-400 hover:text-white hover:bg-neutral-800/50'
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>
      )}
    </nav>
  );
}
